const carRental = {
  carRental: "Noleggio auto", // translated
  carRentals: "Noleggio auto", // translated
  pickUpPoint: "Punto di ritiro", // translated
  dropOffPoint: "Punto di riconsegna", // translated
  pickUpDate: "Data di ritiro", // translated
  dropOffDate: "Data di riconsegna", // translated
  pickUp: "Raccolta", // translated
  dropOff: "Riconsegna", // translated
  edit: "Modificare", // translated
  fuelPolicy: "Politica sul carburante", // translated
  pickUpLocation: "Posto di raccolta", // translated
  mileage: "Chilometraggio", // translated
  transmission: "Trasmissione", // translated
  airCondition: "Aria condizionata", // translated
  minimumAge: "Età minima", // translated
  maximumAge: "Età massima", // translated
  providerAddress: "Indirizzo del fornitore", // translated
  providerPhone: "Telefono del fornitore", // translated
  driverInfo: "Informazioni sul conducente", // translated
  driversInfo: "Informazioni sul conducente", // translated
  differentDropOff: "Riconsegna in un luogo diverso", // translated
  maxPassengers: "Numero massimo di passeggeri", // translated
  budget: "Bilancio", // translated
  provider: "Fornitore", // translated
  carModel: "Modello d'auto", // translated
  numOfDoors: "Numero di porte", // translated
  fuelType: "Tipo di carburante", // translated
  driverAge: "Età del conducente", // translated
  workingHours: "Ore lavorative", // translated
  driverNationality: "Nazionalità del conducente", // translated
  carRentalRate: "Tariffa noleggio auto", // translated
  dueNow: "Scadenza adesso", // translated
  duePickUp: "Scadenza al ritiro", // translated
  toViewOfferPDF: "Per visualizzare un documento PDF contenente tutti i termini di noleggio di questa offerta, per favore", // translated
  toViewTermsAndCondPDF: "Per visualizzare i Termini e Condizioni CARNECT applicabili, per favore", // translated
};


export default carRental;
